module.exports = __webpack_public_path__ + "static/media/vg_unactivated.c17eae54.svg";